<template>
    <div id="app">
        <div class="container mt-2 mb-5">
            <div class="row">
                <div class="col md-12 text-center mt-5 mb-3">
                    <img :src="require('@/assets/logo-main.webp')"
                    class="img-fluid" width="250" />
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div ref="lottieContainer"
                        style="width: 100%; max-width: 333px; height: auto; aspect-ratio: 1; margin: 0 auto; display: flex; justify-content: center; align-items: center;">
                    </div>
                    <h2 class="text-center mb-3 mt-3">Pago Exitoso</h2>
                </div>
                <div class="col-md-4 mx-auto text-center">
                    <p class="text-justify">
                        ¡Gracias por tu pago! Tu transacción ha sido exitosa. En breve serás redireccionado a tu
                        dashboard del expediente clínico, donde podrás comenzar a gestionar toda la información de
                        tus pacientes de manera segura y eficiente.
                    </p>

                    <p class="text-center mt-4">
                        <strong class="fw-bold">Espera un momento, te estamos redireccionando... ⏳</strong>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    var config = require("@/config/api.json");
    const API = config.api;
    import lottie from 'lottie-web';
    import successAnim from '@/assets/animaciones/success.json';

    export default {
        name: "PagoExitoso",
        data() {
            return {
                showNotification: false,
                personal_medio_id: null,
                paquete_id: null,
                isActivated: false // Bandera para controlar la activación
            };
        },
        async created() {
            // Obtener parámetros de la URL
            this.personal_medio_id = this.$route.query.u;
            this.paquete_id = this.$route.query.p;
            console.log('Usuario ID:', this.personal_medio_id);
            console.log('Plan ID:', this.paquete_id);

            // Activar el paquete si no se ha activado
            if (!this.isActivated) {
                await this.activarPaquete();
                this.isActivated = true; // Marcar como activado
            }

            setTimeout(() => {
                this.$router.push('/home'); // Redirigir a la página de inicio
            }, 9000);

            const light = localStorage.getItem('light');
            console.log('PRIMER LIGHT', light)

            if (light !== null) {
                // La variable existe en localStorage
                console.log('La variable existe en localStorage');
                document.body.classList.toggle('light-mode', light);
            } else {
                document.body.classList.toggle('light-mode', false);
            }
        },
        mounted() {
            lottie.loadAnimation({
                container: this.$refs.lottieContainer,
                renderer: 'svg',
                loop: false,
                autoplay: true,
                animationData: successAnim // 👈 en vez de usar path
            });
        },
        methods: {
            async activarPaquete() {
                try {
                    const response = await axios.post(`${API}/activar-pago`, {
                        personal_medico_id: this.personal_medio_id,
                        paquete_id: this.paquete_id
                    });

                    if (response.data.status === 'success') {
                        console.log('Paquete activado exitosamente:', response.data);
                        await this.callAudit(this.personal_medio_id,"ACTIVACION","paquetes_contratados",this.paquete_id,"Activación de paquete");
                        // Limpiar los parámetros de la URL
                        this.$router.replace({ path: '/pago-exitoso' });

                        this.personal_medio_id = null;
                        this.paquete_id = null;

                        setTimeout(() => {
                            this.$router.push('/home'); // Redirigir a la página de inicio
                        }, 6000);
                    } else {
                        console.error('Error al activar el paquete:', response.data.message);
                    }
                } catch (error) {
                    console.error('Error al conectar con el backend para activar el paquete:', error);
                }
            }
        },
    };
</script>

<style scoped>
    .blurred {
        filter: blur(5px);
        pointer-events: none;
    }
</style>